export const contactConstants = {
    CONTACT_SEND_REQUEST: 'CONTACT_SEND_REQUEST',
    CONTACT_SEND_SUCCESS: 'CONTACT_SEND_SUCCESS',
    CONTACT_SEND_FAILURE: 'CONTACT_SEND_FAILURE',

    CONTACT_SENDING_REQUEST: 'CONTACT_SENDING_REQUEST',
    CONTACT_FORM_CLEAR: 'CONTACT_FORM_CLEAR',
    CONTACT_CLEAR_ERROR: 'CONTACT_CLEAR_ERROR',
    CONTACT_CLEAR_STATE: 'CONTACT_CLEAR_STATE',
};